<template>
  <div>
    <chart-card :chart-data="data"
                :chart-options="options"
                :responsive-options="responsiveOptions"
                chartType="Bar"
                :render="render">
      <template slot="header">
        <h4 class="card-title">Evolution over time</h4>
        <p class="card-category">{{subtitle}}</p>
      </template>
      <template slot="footer">
        <div class="legend">
          <i class="fas fa-circle ct-legend-a"></i> Received &nbsp;
          <i class="fas fa-circle ct-legend-b"></i> Closed &nbsp;
          <span> <strong><b>%</b></strong> Close Rate </span>
        </div>
        <hr>
        <div class="stats">
          2019-01 &nbsp; <i class="fas fa-arrow-alt-right"/> &nbsp; 2019-12
        </div>
      </template>
    </chart-card>
  </div>
</template>

<script>
import {ChartCard} from 'src/components/index'
export default {
  name: 'Payouts-Graph-Single-View-Card',
  components: {
    ChartCard
  },
  props: {
    render: {type: Boolean, default: false},
    show:   {type: String, default: 'Total'}
  },
  data () {
    return {
      options: {
        seriesBarDistance: 6,
        axisX: {
          showGrid: false
        },
        height: '245px'
      },
      responsiveOptions: [
        ['screen and (max-width: 640px)', {
          seriesBarDistance: 5,
          axisX: {
            labelInterpolationFnc (value) {
              return value[0]
            }
          }
        }]
      ]
    }
  },
  computed: {
    periodSelected () {
      return this.$store.getters.periodSelected
    },
    subtitle () {
      if (this.periodSelected) {
        return this.$store.getters.periodEvolution.label
      }
      return ''
    },
    barChart () {
      if (this.$store.getters.payoutsEvolution && this.$store.getters.payoutsEvolution.barCharts) {
        switch (this.show) {
          case 'Pending':
            return this.$store.getters.payoutsEvolution.barCharts.pending
          case 'ToSubmit':
            return this.$store.getters.payoutsEvolution.barCharts.toSubmit
          case 'Submitted':
            return this.$store.getters.payoutsEvolution.barCharts.submitted
          case 'Paid':
            return this.$store.getters.payoutsEvolution.barCharts.paid
          case 'Total':
            return this.$store.getters.payoutsEvolution.barCharts.total
          default:
            console.log('!!! problem with prop show: ', this.show)
            return {}
        }
      }
      else {
        return {}
      }
    },
    data () {
      return this.barChart ? this.barChart.data : {}
    },/* 
    options () {
      return this.lineChart.options
    },
    responsiveOptions () {
      return this.lineChart.responsiveOptions
    } */
  }
}
</script>

<style>

</style>